
import { granjaApi } from "../../api";
import { useConsumosStore } from "../../store";

import Swal from "sweetalert2";






export const startConsumosXLote = async(id) => {
    try {
        const { data } = await granjaApi.get(`/consumo/xlotedistri/${id}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}





export const startConsumoXLote = async({ page=0, id, inicio, final }) => {
    try {
        const params = new URLSearchParams();
        params.append('id',  id);
        params.append('page',  page.toString());
        params.append('inicio',  inicio);
        params.append('final',  final);

        const { data } = await granjaApi.get('/consumo/xlote', { params });
        useConsumosStore.setState({ totalConsumo: data.total, datosConsumo: data.datos });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingConsumo = async(consumo) => {
    try {
        await granjaApi.post('/consumo/new', consumo);
        Swal.fire('Exitoso', 'Consumo Creado', 'success');
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 




export const startEliminarConsumo = async(id) => {
    try {
        const { data } = await granjaApi.delete(`/consumo/${id}`);
        Swal.fire('Exitoso', 'Consumo Eliminado', 'success');
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}